export const ROUTES = {
  // ── Auth (shared — single login page for all portals) ─────────────────
  AUTH: {
    LOGIN: '/auth/login',
    CLINICIAN_LOGIN: '/auth/login', // alias for backward compat
    FORGOT_PASSWORD: '/auth/forgot-password',
    VERIFY_OTP: (email: string) => `/auth/verify-otp/${encodeURIComponent(email)}`,
    VERIFY_OTP_RESET: (email: string) => `/auth/reset-password/${encodeURIComponent(email)}`,
    SET_PASSWORD: (otp: string, username: string) =>
      `/auth/set-password/${otp}/reset/${encodeURIComponent(username)}`,
  },

  // ── Clinician/Admin Portal ────────────────────────────────────────────
  APP: {
    /** The portal root: lands on the first page the signed-in role may open. */
    ROOT: '/app',
    DASHBOARD: '/app/dashboard',
    CLINICS: '/app/clinics',
    CLINICS_DETAIL: (id: string) => `/app/clinics/${id}`,
    USERS: '/app/users',
    USERS_DETAIL: (id: string) => `/app/users/${id}`,
    CLIENTS: '/app/clients',
    CLIENTS_DETAIL: (id: string) => `/app/clients/${id}`,
    CLIENTS_DETAIL_TAB: (id: string, tab: string) => `/app/clients/${id}/${tab}`,
    APPOINTMENTS: '/app/appointments',
    APPOINTMENTS_AVAILABILITY: '/app/appointments/availability',
    ENCOUNTERS: '/app/encounters',
    ENCOUNTER_DETAIL: (encounterUuid: string) => `/app/encounters/${encounterUuid}`,
    TASKS: '/app/tasks',
    SUBSCRIPTIONS: '/app/subscriptions',
    COMMUNICATIONS: '/app/communications',
    LAB_ORDERS: '/app/lab-orders',
    PRESCRIPTIONS: '/app/prescriptions',
    INVENTORY: '/app/inventory',
    SUPERBILLS: '/app/superbills',
    REPORTS: '/app/reports',
    PLAN_OF_CARE: '/app/plan-of-care',
    PLAN_OF_CARE_DETAIL: (commercialPlanUuid: string) => `/app/plan-of-care/${commercialPlanUuid}`,
    AFFILIATES: '/app/affiliates',
    SETTINGS: '/app/settings',
    SETTINGS_INTAKE_FORMS: '/app/settings/intake-forms',
    SETTINGS_CONSENT_FORMS: '/app/settings/consent-forms',
    SETTINGS_CODES: '/app/settings/codes',
    SETTINGS_PLAN_OF_CARE: '/app/settings/plan-of-care',
    SETTINGS_PLAN_OF_CARE_BY_GENDER: (gender: 'male' | 'female') =>
      `/app/settings/plan-of-care/${gender}`,
    SETTINGS_PLAN_OF_CARE_CONFIGURATIONS: (gender: 'male' | 'female' = 'male') =>
      `/app/settings/plan-of-care/configurations?gender=${gender}`,
    SETTINGS_CHARGE_LIST: '/app/settings/charge-list',
    SETTINGS_DISCOUNTS: '/app/settings/discounts',
    SETTINGS_ROOMS: '/app/settings/rooms',
    SETTINGS_FORM_BUILDER: '/app/settings/form-builder',
    SETTINGS_BY_TAB: (
      tab:
        | 'intake-forms'
        | 'consent-forms'
        | 'codes'
        | 'plan-of-care'
        | 'charge-list'
        | 'discounts'
        | 'rooms'
        | 'form-builder'
        | 'templates'
        | 'roles-permissions',
    ) => `/app/settings/${tab}`,
    SETTINGS_CHARGE_LIST_BY_STATUS: (status: 'active' | 'archived') =>
      `/app/settings/charge-list/${status}`,
    PROFILE: '/app/profile',
    LAB_ORDERS_OAUTH_CALLBACK: '/app/lab-orders/oauth/callback',
  },

  TELEHEALTH: {
    ROOM: (room: string) => `/telehealth/${encodeURIComponent(room)}`,
  },

  // ── Patient Portal ────────────────────────────────────────────────────
  PATIENT: {
    DASHBOARD: '/patient/dashboard',
    APPOINTMENTS: '/patient/appointments',
    DOCUMENTS: '/patient/documents',
    SUBSCRIPTIONS: '/patient/subscriptions',
    PLAN_OF_CARE: '/patient/plan-of-care',
    PLAN_OF_CARE_DETAIL: (commercialPlanUuid: string) =>
      `/patient/plan-of-care/${commercialPlanUuid}`,
    LAB_REPORTS: '/patient/lab-reports',
    RECOMMENDATIONS: '/patient/recommendations',
    SUPPLEMENTS: '/patient/supplements',
    PURCHASES: '/patient/purchases',
    SUPERBILLS: '/patient/superbills',
    PAYMENT_METHODS: '/patient/payment-methods',
    SETTINGS: '/patient/settings',
    PROFILE: '/patient/profile',
  },
} as const
